import PageBreadcrumb from "../../../../shared/ui/common/PageBreadCrumb";
import PageMeta from "../../../../shared/ui/common/PageMeta";
import { useTranslation } from "react-i18next";

export default function Support() {
    const { t } = useTranslation();

    return (
        <>
            <PageMeta />
            <PageBreadcrumb pageTitle={t("support.pageTitle")} />

            <div className="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03] lg:p-6">
                <div className="space-y-6">
                    <h3 className="mb-5 text-lg font-semibold text-content-primary lg:mb-7">
                        {t("support.aboutTitle")}
                    </h3>
                    <p className="text-content-tertiary">
                        {t("support.intro")}
                    </p>
                    <p className="text-content-tertiary">
                        {t("support.concept")}
                    </p>

                    <ul className="list-disc pl-5 space-y-2 text-content-tertiary">
                        <li>{t("support.feature1")}</li>
                        <li>{t("support.feature2")}</li>
                        <li>{t("support.feature3")}</li>
                        <li>{t("support.feature4")}</li>
                        <li>{t("support.feature5")}</li>
                        <li>{t("support.feature6")}</li>
                    </ul>

                    <p className="text-content-tertiary">
                        {t("support.conclusion")}
                    </p>

                    <div className="mt-8 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg">
                        <h4 className="font-semibold text-content-primary mb-2">
                            {t("support.contactTitle")}
                        </h4>
                        <p className="text-sm text-content-tertiary">
                            {t("support.contactDescription")} <a href="mailto:hello@alchely.com" className="text-brand-500 hover:underline">hello@alchely.com</a>
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
}
